// MMT1Slice - single dataset implementation mirroring MMT3 loadData pattern
import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { axiosInstance } from '../../AxiosInterceptor/axiosInterceptor';
import { MmtByScenarioDetail } from '../../Table/TableQueryColumn';
const MMT_REPORTS_API_BASE = process.env.REACT_APP_MMT_REPORTS;

const initialState = {
	loadData: {
		totalCount: 0,
		page: 0,
		pageSize: 50,
		collectionName: 'MmtByScenario',
		data: [],
		loading: false,
		error: false,
		lastRefreshedDate: ''
	}
};

// Thunk: fetch MMT1 scenario details
export const getMmt1ScenarioDetailsData = createAsyncThunk('mmt1/getMmt1ScenarioDetailsData',
	async (_, { rejectWithValue }) => {
		try {
			let query = `query {GetMmtByScenarioDetails(collectionName: "MmtByScenario"`;
			query += MmtByScenarioDetail; // fragment already closes braces

			const response = await axiosInstance.post(MMT_REPORTS_API_BASE,
				JSON.stringify({ query, variables: {} })
			);

			if (response.data.errors && response.data.errors.length > 0) {
				const errorMessages = response.data.errors.map(err => err.message).join(', ');
				return rejectWithValue(errorMessages);
			}

			return JSON.stringify(response);
		} catch (err) {
			return rejectWithValue(err.message || 'Unexpected error');
		}
	}
);

const mmt1Slice = createSlice({
	name: 'mmt1',
	initialState,
	reducers: {
		clearData: (state) => {
			state.loadData = initialState.loadData;
		}
	},
	extraReducers: (builder) => {
		builder
			.addCase(getMmt1ScenarioDetailsData.pending, (state) => {
				state.loadData.loading = true;
				state.loadData.error = false;
			})
			.addCase(getMmt1ScenarioDetailsData.fulfilled, (state, action) => {
				const response = JSON.parse(action.payload);
				state.loadData.loading = false;
				state.loadData.error = false;
				// MMT-3 pattern: lastUpdated assignment only if provided (else leave blank)
				if (response?.data?.data?.GetMmtByScenarioDetails?.lastRefreshedDate) {
					state.loadData.lastRefreshedDate = response.data.data.GetMmtByScenarioDetails.lastRefreshedDate;
				}
				state.loadData.data = response.data.data.GetMmtByScenarioDetails.data;
				state.loadData.totalCount = response.data.data.GetMmtByScenarioDetails.totalCount || state.loadData.data.length;
			})
			.addCase(getMmt1ScenarioDetailsData.rejected, (state) => {
				state.loadData.loading = false;
				state.loadData.error = true;
			});
	}
});

export const { clearData } = mmt1Slice.actions;
export default mmt1Slice.reducer;